import script from "./AddFounder.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddFounder.vue?vue&type=script&setup=true&lang=ts"

import "./AddFounder.vue?vue&type=style&index=0&id=2bdd6935&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bdd6935"]])

export default __exports__